import React, { Component } from 'react';
import AuthService from '../service/AuthService' ;

class RegisterComponent extends Component{

  constructor(props) {
    super(props);
    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangePasswordConfirm = this.onChangePasswordConfirm.bind(this);

    this.state = {
      name:"",
      username: "",
      email: "",
      password: "",
      passwordConfirm:"",
      isPasswordMatch : true,
      successful: false,
      message: "",
      loading: false,
      errorMessage : ""
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeName(e) {
    this.setState({
      name: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  onChangePasswordConfirm(e) {
    this.setState({
      passwordConfirm: e.target.value
    });
    if (this.state.password === e.target.value)
      this.setState({
        isPasswordMatch: true
      }); 
    else
    this.setState({
      isPasswordMatch: false
    }); 
  }

  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      errorMessage : "",
      successful: false,
      loading : true
    });
    // valider les forms
    if (!this.state.isPasswordMatch) {
      this.setState({
        message: "Les mots de passe saisis sont différents",
        successful: false,
        loading : false
      });


    } else {
      AuthService.register(
        this.state.name,
        this.state.username,
        this.state.email,
        this.state.password
      ).then(
        response => {
          let isSucessful = response.data.errorMessage ? false : true;
          let messageTemp = isSucessful ? response.data.message : response.data.errorMessage
          this.setState({
            message: messageTemp,
            successful: isSucessful,
            loading : false
          });
        })
        .catch(error => {
          //console.log(error);
          this.setState({message: error.response.data.message});
          this.setState({isSuccess: false});
          this.setState({loading: false});
      });
      
      
    }
  }


    render() {
        return(

    <div class="text-center py-2" style={style}>
    <div class="container">
      <div class="row">
        <div class="mx-auto col-lg-6 col-10">
          <h1>Parmi nous dans quelques instants</h1>
          <p class="mb-3">Saisissez qualques infos basiques et un mot de passe. C'est tout !</p>
            {this.state.message && (
              <div>
                <div
                  className={
                    this.state.successful
                      ? "alert alert-success alert-dismissible"
                      : "alert alert-danger alert-dismissible"
                  }
                  style = {{'white-space': 'pre-wrap'}}

                  role="alert"
                >
                  {this.state.successful ? <strong>OK! </strong> : <strong>KO! </strong> }
                  {this.state.message}
                </div>
              </div>
            )}
            {!this.state.successful && (
          
          <form class="text-left">
            <div class="form-group"> <label for="name">Votre nom</label> <input type="text" class="form-control" id="name" placeholder="Nom"value={this.state.name} onChange={this.onChangeName}/> </div>
            <div class="form-group"> <label for="username" >Votre username</label> <input type="text" class="form-control" id="username" placeholder="Nom utilisteur" value={this.state.username} onChange={this.onChangeUsername}/> </div>
            <div class="form-group"> <label for="email">Votre email</label> <input type="email" class="form-control" id="email" placeholder="email@exemple.com" value={this.state.email} onChange={this.onChangeEmail}/> </div>
            <div class="form-row">
              <div class="form-group col-md-6"> <label for="password">Mot de passe</label> <input type="password" class="form-control" id="password" placeholder="••••" value={this.state.password} onChange={this.onChangePassword}/> </div>
              <div class="form-group col-md-6"> 
              <label for="passwordConfirm">Confirmation mot de passe 
              {this.state.passwordConfirm &&
                    (<span className={
                    this.state.isPasswordMatch ? "badge badge-success": "badge badge-warning"} >
                    {this.state.isPasswordMatch ? 'OK' : 'KO'}</span>)}
              </label>
             <input type="password" class="form-control" id="passwordConfirm" placeholder="••••"  value={this.state.passwordConfirm} onChange={this.onChangePasswordConfirm}/> </div>
            </div>
            <div class="form-group">
              <div class="form-check"> <input class="form-check-input" type="checkbox" id="form21" value="on"/> <label class="form-check-label" for="form21"> J'accepte les termes et conditions du service</label> </div>
            </div> 
            
            <button class="btn btn-info" 
                onClick={this.handleRegister} 
                disabled={this.state.loading}>
                Sign in
            </button>
            {this.state.loading && (<span className="spinner-border spinner-border-sm"></span> )}
          </form>
          
          )}
        </div>
      </div>
    </div>
  </div>


        );
    }
}

const style={
  "background-image": "linear-gradient(to left bottom, rgba(189, 195, 199, .1), rgba(44, 62, 80, .25))",
  "background-size": "100%"
  }
export default RegisterComponent;